import React from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Card,
  CardHeader,
  Table,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
} from "reactstrap";
import "../../styles/estilos.css";
import Page from "components/Page";
import Pagination from "react-js-pagination";
import { FetchPost } from "../../redux/actions/api";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { urlListarCotizaciones } from "../../constants/urls";
import { ambienteAplicacion } from "../..//constants/urls";
import { Select } from "react-inputs-validation";
import { listarColoresFetch } from "../../redux/actions/aCotizacion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import "../../styles/table.scss";
import { resetInitResp } from "../../redux/actions/aCotizacionResponsabilidad";

class ListadoCotizaciones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      cotizaciones: [],
      cotizacionesOri: [],
      numeroElementos: 0,
      isLoading: true,
      filtro: "",
      filtroselect: [],
      filtroValor: "",
    };
  }

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber });
  };

  async componentDidMount() {
    await this.props.listarColores();
    let resp = await FetchPost({
      url: urlListarCotizaciones,
      param: {
        empresa: "AIGMETROPOLITANA",
        idUsuario: this.props.dataUsuario.cliCodigoCore,
        ambiente: ambienteAplicacion,
      },
    });
    const { transaccion, leads, ramosfiltro } = resp;
    if (transaccion) {
      const cotizaciones = leads.map((item, index) => ({
        ...item,
        contador: index + 1,
      }));
      this.setState({
        cotizaciones,
        cotizacionesOri: cotizaciones,
        numeroElementos: cotizaciones.length,
        isLoading: false,
        filtroselect: ramosfiltro,
      });
    }
  }

  handleAplicarFiltro = () => {
    let { filtro, cotizacionesOri, filtroValor } = this.state;
    filtro = filtro.toUpperCase();
    const cotizaciones = cotizacionesOri.filter(
      ({ placas, identificacionAsegurados, ramoNombre, fecha, nombresAsegurados }) => {
        if (!placas) placas = "";
        if (!identificacionAsegurados) identificacionAsegurados = "";
        if (!fecha) fecha = "";
        if (!nombresAsegurados) nombresAsegurados = "";
        if (!ramoNombre) ramoNombre = "";
        return (
          (placas.indexOf(filtro) > -1 ||
            ramoNombre.indexOf(filtro) > -1 ||
            fecha.indexOf(filtro) > -1 ||
            nombresAsegurados.indexOf(filtro) > -1 ||
            identificacionAsegurados.indexOf(filtro) > -1) &&
          ramoNombre.indexOf(filtroValor) > -1
        );
      }
    );
    this.setState({ cotizaciones });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filtroValor !== this.state.filtroValor) {
      this.handleAplicarFiltro();
    }
  }

  handleOnClick = async (params) => {
    const { url, ramo, esParametrico, carCodigoCotizador } = params;
    const param = new URLSearchParams(url);
    const id = param.get("id");

    if (esParametrico) {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: `/${url.substring(0, i)}`,
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    } else if (ramo === "HOGAR") {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: `/${url.substring(0, i)}`,
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    } else if (ramo === "LÍNEAS FINANCIERAS") {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: `/${url.substring(0, i)}`,
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    } else if (ramo === "TRAVEL") {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: `/${url.substring(0, i)}`,
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    } else if (ramo === "ACCIDENTES PERSONALES") {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: `/${url.substring(0, i)}`,
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    } else if (ramo === "PYMES") {
      let i = url.indexOf("?id");
      this.props.history.push({
        pathname: "pymes/cotizador",
        search: `${url.substring(i)}`, //agregar parametros de la url,
      });
    } else if (ramo === "RCANDINA") {
      let i = url.indexOf("?id");
      this.props.history.push({
        pathname: "rc-andina/cotizador",
        search: `${url.substring(i)}`, //agregar parametros de la url,
      });
    } else if (
      ramo === "MOTOS" ||
      ramo === "MOTO" ||
      ramo === "VEHÍCULOS - MOTOS" ||
      ramo === "VEHICULOS - MOTOS" ||
      (ramo && ramo.toUpperCase().includes("MOTO")) ||
      (url && url.includes("motos"))
    ) {
      if (url) {
        let i = url.indexOf("?");
        let searchStr = i !== -1 ? url.substring(i) : `?idCarrito=${url}`;
        const queryParams = new URLSearchParams(searchStr);
        const idCar = queryParams.get("idCarrito") || queryParams.get("id") || (i !== -1 ? url.substring(i + 1) : url);
        this.props.history.push({
          pathname: "/motos/emision",
          search: `?idCarrito=${idCar}`,
        });
      }
    } else {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: this.obtenerUrl(url),
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    }
  };


  obtenerUrl = (url) => {

    if (url.includes("resumen-cotizacion-renovacion")) {
      return "resumen-cotizacion-renovacion"
    } else {
      return "resumen-cotizacion"
    }


  }

  bodyVerDetalles = (compras) => {
    return (
      <React.Fragment>
        {(compras.urlCorizacion && compras.urlCorizacion != '') &&
          <Button
            className={"btn btn-primary"}
            onClick={() => {
              // resetear estado cotizacion pestana actual
              this.props.resetResp();
              // handle on click
              this.handleOnClick({
                url: compras.urlCorizacion,
                ramo: compras.ramoNombre,
                esParametrico: compras.esParametrico,
                carCodigoCotizador: compras.codigoCotizador
              });
            }}
            style={{
              display: "block",
              margin: "auto",
            }}
          >
            <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
            {"DETALLES COTIZACION"}
          </Button>
        }

      </React.Fragment>

    );
  };

  render() {
    const {
      activePage,
      cotizacionesOri,
      cotizaciones,
      isLoading,
      filtroselect,
      filtroValor,
    } = this.state;
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <LoadingScreen
              loading={isLoading}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text={"Cargando Lista de Cotizaciones..."}
            >
              <Page
                title="Listado de Cotizaciones"
                breadcrumbs={[
                  { name: "Listado de Cotizaciones", active: true },
                ]}
              >
                {cotizacionesOri.length > 0 && (
                  <div>
                    <Row>
                      <Col lg={8} md={12} sm={12} xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            maxWidth: 1000,
                            marginBottom: 10,
                          }}
                        >
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                Placa o Identificación:
                              </InputGroupText>
                            </InputGroupAddon>

                            <Input
                              onChange={(e) => {
                                let val = e.target.value;
                                if (val)
                                  this.setState({ filtro: e.target.value });
                                else
                                  this.setState({
                                    filtro: e.target.value,
                                    cotizaciones: this.state.cotizacionesOri,
                                  });
                              }}
                              value={this.state.filtro}
                              style={{ minWidth: 200 }}
                              onKeyUp={(e) => {
                                if (e.key === "Enter") {
                                  this.handleAplicarFiltro();
                                }
                              }}
                            />
                          </InputGroup>

                          <Button
                            className={"btn btn-primary"}
                            onClick={() => this.handleAplicarFiltro()}
                            style={{ display: "block", margin: "auto" }}
                          >
                            <i
                              className="fa fa-chevron-circle-right"
                              aria-hidden="true"
                            />{" "}
                            {"BUSCAR"}
                          </Button>
                          <br />
                        </div>
                      </Col>
                      <Col lg={4} md={12} sm={12} xs={12}>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>Ramo</InputGroupText>
                          </InputGroupAddon>
                          <div style={{ width: "270px" }}>
                            <Select
                              tabIndex="1" // Optional.[String or Number].Default: none.
                              id={"SelectRamo"} // Optional.[String].Default: "". Input ID.
                              name={"SelectRamo"} // Optional.[String].Default: "". Input name.
                              value={filtroValor} // Optional.[String].Default: "".
                              optionList={filtroselect} // Required.[Array of Object(s)].Default: [].
                              onChange={(selec, e) => {
                                this.setState({ filtroValor: selec });
                              }}
                              // Optional.[Func].Default: () => {}. Will return the value.
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "SelectRamo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: false, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "",
                              }}
                            />
                          </div>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="detalle-cotizacion-box"
                      >
                        <Card className="mb-3">
                          <CardHeader
                            style={{ borderBottom: "none" }}
                          ></CardHeader>
                          <CardBody>
                            {cotizaciones.length > 0 && (
                              <DataTable
                                value={cotizaciones}
                                responsive
                                className="p-datatable-customers"
                                rowHover
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 25, 50]}
                                emptyMessage="No se han encontrado resultados"
                                resizableColumns
                              //currentPageReportTemplate="Visualizando {first} hasta {last} de {totalRecords} registros"
                              //paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                              >
                                <Column
                                  className="counter"
                                  field="contador"
                                  header="#"
                                  sortable
                                  style={{ width: "60px" }}
                                />
                                <Column
                                  field="fecha"
                                  header="Fecha"
                                  sortable
                                  style={{ width: "100px" }}
                                />
                                <Column
                                  header="Nombres de los Asegurados"
                                  field="nombresAsegurados"
                                  sortable
                                  style={{ width: "150px" }}
                                />
                                <Column
                                  header="Identificación de los Asegurados"
                                  field="identificacionAsegurados"
                                  sortable
                                  style={{ width: "150px" }}
                                />
                                <Column
                                  header="Placa"
                                  field="placas"
                                  sortable
                                  style={{ width: "150px" }}
                                />
                                <Column
                                  header="Ramo"
                                  field="ramoNombre"
                                  sortable
                                  style={{ width: "150px" }}
                                />
                                <Column
                                  header="Producto"
                                  field="producto"
                                  sortable
                                  style={{ width: "150px" }}
                                />
                                <Column
                                  header="Detalles"
                                  body={this.bodyVerDetalles}
                                  style={{ width: "220px" }}
                                />
                              </DataTable>
                            )}
                            {cotizaciones.length === 0 && (
                              <Row>
                                <Col
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  className="detalle-cotizacion-box"
                                >
                                  <Card className="mb-3">
                                    <CardHeader
                                      style={{ borderBottom: "none" }}
                                    ></CardHeader>
                                    <CardBody>
                                      <h2
                                        style={{
                                          color: "#001871",
                                          textAlign: "center",
                                        }}
                                      >
                                        {" "}
                                        NO SE HA ENCONTRADO REGISTROS DE
                                        COTIZACIONES
                                      </h2>
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                            )}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                )}

                {cotizacionesOri.length === 0 && (
                  <Row>
                    <Col
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="detalle-cotizacion-box"
                    >
                      <Card className="mb-3">
                        <CardHeader
                          style={{ borderBottom: "none" }}
                        ></CardHeader>
                        <CardBody>
                          <h2 style={{ color: "#001871", textAlign: "center" }}>
                            {" "}
                            NO SE HA ENCONTRADO REGISTROS DE COTIZACIONES
                          </h2>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                )}
              </Page>
            </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  dataUsuario: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = (dispatch) => {
  return {
    listarColores: () => dispatch(listarColoresFetch()),
    resetResp: () => dispatch(resetInitResp()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListadoCotizaciones)
);

/*

                              <div>
                                <Table
                                  className="table-bordered"
                                  style={{ textAlign: "center" }}
                                  responsive
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={{ border: "1px solid #dee2e6" }}
                                      >
                                        #
                                      </th>
                                      <th
                                        style={{ border: "1px solid #dee2e6" }}
                                      >
                                        Fecha
                                      </th>
                                      <th
                                        style={{ border: "1px solid #dee2e6" }}
                                      >
                                        Nombres de los Asegurados
                                      </th>
                                      <th
                                        style={{ border: "1px solid #dee2e6" }}
                                      >
                                        Identificación de los Asegurados
                                      </th>
                                      <th
                                        style={{ border: "1px solid #dee2e6" }}
                                      >
                                        Placa
                                      </th>
                                      <th
                                        style={{ border: "1px solid #dee2e6" }}
                                      >
                                        Ramo
                                      </th>
                                      <th
                                        style={{ border: "1px solid #dee2e6" }}
                                      >
                                        Detalles
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {cotizaciones.map((compras, index) => {
                                      const fin = activePage * 10;
                                      const inicio = fin - 10;
                                      if (index >= inicio && index < fin)
                                        return (
                                          <tr key={Math.random()}>
                                            <td
                                              style={{
                                                border: "1px solid #dee2e6",
                                              }}
                                            >
                                              {index + 1}
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #dee2e6",
                                              }}
                                            >
                                              {compras.fecha}
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #dee2e6",
                                              }}
                                            >
                                              {compras.nombresAsegurados}
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #dee2e6",
                                              }}
                                            >
                                              {compras.identificacionAsegurados}
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #dee2e6",
                                              }}
                                            >
                                              {compras.placas}
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #dee2e6",
                                              }}
                                            >
                                              {compras.ramoNombre}
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #dee2e6",
                                              }}
                                            >
                                              <Button
                                                className={"btn btn-primary"}
                                                onClick={() => {
                                                  this.handleOnClick({
                                                    url: compras.urlCorizacion,
                                                    ramo: compras.ramoNombre,
                                                  });
                                                }}
                                                style={{
                                                  display: "block",
                                                  margin: "auto",
                                                }}
                                              >
                                                <i
                                                  className="fa fa-chevron-circle-right"
                                                  aria-hidden="true"
                                                />{" "}
                                                {"DETALLES COTIZACION"}
                                              </Button>
                                            </td>
                                          </tr>
                                        );
                                      else return null;
                                    })}
                                  </tbody>
                                </Table>

                                <Row>
                                  <Col lg={12} md={12} sm={12} xs={12}>
                                    <Pagination
                                      activePage={this.state.activePage}
                                      itemsCountPerPage={10}
                                      totalItemsCount={
                                        this.state.numeroElementos
                                      }
                                      pageRangeDisplayed={5}
                                      onChange={this.handlePageChange}
                                      linkClass={"paginaciontaga"}
                                      activeLinkClass={"activepagination"}
                                      innerClass={
                                        "pagination centrarpagination"
                                      }
                                    />
                                  </Col>
                                </Row>
                              </div>

*/